import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import api from "@/lib/api";

/** قائمة الهيدر في وضع التوليد الفردي: اختيار مشروع التوليد الفردي والتنقل بين مشاريعه (الاستوديو والمكتبة) */
export const StudioSwitcher = ({ t }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const params = new URLSearchParams(location.search);
  const sp = params.get("sp") || "all";
  // يُعاد التحميل عند تغيّر الصفحة أو عند اختيار مشروع جديد غير موجود بالقائمة (أُنشئ للتو من شريط الاستوديو)
  useEffect(() => { api.get("/me/studio-projects").then((r) => setList(r.data)).catch(() => {}); }, [location.pathname, sp !== "all" && !list.some((p) => p.id === sp) ? sp : ""]); // eslint-disable-line react-hooks/exhaustive-deps
  const go = (id) => {
    const q = new URLSearchParams(location.search);
    q.set("individual", "1");
    if (id === "all") q.delete("sp"); else q.set("sp", id);
    navigate(`${location.pathname}?${q.toString()}`);
  };
  return (
    <div className="flex items-center gap-2" data-testid="studio-switcher">
      <span className="text-xs text-primary hidden sm:inline" data-testid="individual-standalone-badge">{t("التوليد الفردي:", "Individual:")}</span>
      <Select value={sp} onValueChange={go}>
        <SelectTrigger className="w-[200px] bg-secondary border-border" data-testid="studio-switcher-select"><SelectValue placeholder={t("مشروع التوليد الفردي", "Individual project")} /></SelectTrigger>
        <SelectContent className="bg-popover border-border">
          <SelectItem value="all" data-testid="studio-switcher-all">{t("كل مشاريع التوليد الفردي", "All individual projects")}</SelectItem>
          {list.map((p) => <SelectItem key={p.id} value={p.id} data-testid={`studio-switcher-option-${p.id}`}>{p.name}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
};
